








































































/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: {},
})
export default class AreaMapInfo extends Vue {
  private visible = false;
  // 表单数据
  private formData: any = {};
  private areaForm: any = {
    '603fcf8fa7164ccaa57f02a69af71b86S0': {
      dangerSource: '员工行为',
      riskPoint: '硫酸生产',
      areaName: '润丰化工',
      riskLevel: '一般风险',
      riskTypeTagName: '触电',
      energyCharacteristic: '电能',
      controlHierarchy: '车间级',
      riskDescription: '用水冲洗电机，或用潮湿的工具清扫电器设备，湿手启停开关、接触带电设备存在触电的风险',
      hurtDegree: '致命性伤害',
      taskRiskPoint: true,
      possibility: 4,
      seriousness: 8,
      riskDegree: 3,
    },
    '3545c9f9adac40058005c879c7589ac1S0': {
      dangerSource: '作业环境',
      riskPoint: '硫酸生产',
      areaName: '润丰化工',
      riskLevel: '低风险',
      riskTypeTagName: '其他伤害',
      energyCharacteristic: '势能',
      controlHierarchy: '班组级',
      riskDescription: '作业现场照明不足，存在摔倒的风险',
      hurtDegree: '非致命性伤害',
      taskRiskPoint: true,
      possibility: 2,
      seriousness: 4,
      riskDegree: 4,
    },
    '4cba0f3b663240289f2216751d8a49d5S0': {
      dangerSource: '噪声',
      riskPoint: '硫酸生产',
      areaName: '润丰化工',
      riskLevel: '一般风险',
      riskTypeTagName: '噪声危害',
      energyCharacteristic: '物理能',
      controlHierarchy: '车间级',
      riskDescription: '作业现场噪声对人员有职业危害风险',
      hurtDegree: '非致命性伤害',
      taskRiskPoint: true,
      possibility: 3,
      seriousness: 9,
      riskDegree: 3,
    },
    '3b465f2aa0a14b7a91546bbe402792ffS0': {
      dangerSource: '控制柜',
      riskPoint: '硫酸生产',
      areaName: '润丰化工',
      riskLevel: '一般风险',
      riskTypeTagName: '火灾',
      energyCharacteristic: '热能',
      controlHierarchy: '车间级',
      riskDescription: '线路短路、电机过载发热，存在火灾的风险。',
      hurtDegree: '致命性伤害',
      taskRiskPoint: true,
      possibility: 4,
      seriousness: 8,
      riskDegree: 3,
    },
    '16d9374fda584a4d853e8ac8bf45789eS0': {
      dangerSource: '硫酸罐及输酸管道',
      riskPoint: '硫酸生产',
      areaName: '润丰化工',
      riskLevel: '低风险',
      riskTypeTagName: '灼烫',
      energyCharacteristic: '化学能',
      controlHierarchy: '班组级',
      riskDescription: '酸罐阀门及管道锈蚀，硫酸滴漏，巡查时存在灼烫风险。',
      hurtDegree: '非致命性伤害',
      taskRiskPoint: true,
      possibility: 2,
      seriousness: 4,
      riskDegree: 4,
    },
    f5db7de47d454c1aa7799b31f0cf8376S0: {
      dangerSource: '锅炉',
      riskPoint: '硫酸生产',
      areaName: '润丰化工',
      riskLevel: '一般风险',
      riskTypeTagName: '爆炸',
      energyCharacteristic: '热能',
      controlHierarchy: '车间级',
      riskDescription: '安全附件及保护装置失效，导致锅炉内或缺水导致锅炉爆炸的风险。',
      hurtDegree: '致命性伤害',
      taskRiskPoint: true,
      possibility: 4,
      seriousness: 8,
      riskDegree: 3,
    },
    b5f4fd48cecb4e3da9422968e6a2cbe8S0: {
      dangerSource: '沸腾炉',
      riskPoint: '硫酸生产',
      areaName: '润丰化工',
      riskLevel: '一般风险',
      riskTypeTagName: '灼伤',
      energyCharacteristic: '热能',
      controlHierarchy: '班组级',
      riskDescription: '炉体开裂，沸腾炉内矿渣泄漏，导致燃烧、人员灼伤的风险。',
      hurtDegree: '非致命性伤害',
      taskRiskPoint: true,
      possibility: 3,
      seriousness: 6,
      riskDegree: 4,
    },
    b5f4fd48cecb4e3da9422968e6a2cbe8S1: {
      dangerSource: '行车',
      riskPoint: '硫酸生产',
      areaName: '润丰化工',
      riskLevel: '一般风险',
      riskTypeTagName: '起重伤害',
      energyCharacteristic: '势能',
      controlHierarchy: '车间级',
      riskDescription: '在吊装作业时，存在吊装物体或吊钩坠落伤人的风险。',
      hurtDegree: '非致命性伤害',
      taskRiskPoint: true,
      possibility: 3,
      seriousness: 6,
      riskDegree: 4,
    },
    '8cb618b235f14065bc4359e59987c79fS0': {
      dangerSource: '操作室',
      riskPoint: '硫酸生产',
      areaName: '润丰化工',
      riskLevel: '一般风险',
      riskTypeTagName: '触电',
      energyCharacteristic: '电能',
      controlHierarchy: '班组级',
      riskDescription: '接触电脑、饮水机等带电设备存在触电的风险',
      hurtDegree: '非致命伤害',
      taskRiskPoint: true,
      possibility: 2,
      seriousness: 6,
      riskDegree: 4,
    },
  };
  public async showDialog(options: any) {
    this.visible = true;
    console.log(options, 'options');
    this.formData = this.areaForm[options.id];
  }
  private async hideDialog() {
    this.visible = false;
  }
}
